define('pimSearchController',[
  'module',
  'logger',
  'underscore',
  'app',
  'pimSearchView'
], function (
  module,
  Logger,
  _,
  App,
  View
) {
  'use strict';

  var PimSearchController = {
    showSearch: function () {
      var view = new View();
      this.view = view;
      App.regions.getRegion('main').currentView.getRegion('content').show(view);
    }
  };

  module.exports = PimSearchController;
});

